<template>
  <div class="gemini-chat-button-container">
    <!-- Notification Badge -->
    <div class="gemini-notification" :class="{ show: showNotification }">💬 Need assistance? Chat with us!</div>

    <!-- Chat Button -->
    <a
      href="https://gemini.google.com/gem/1w7FBnCyhonCiQsavnlEnFaTR1RfSnAsf?usp=sharing"
      target="_blank"
      class="gemini-chat-button"
      rel="noopener noreferrer"
      @click="handleClick"
    >
      <img src="https://i.pravatar.cc/150?img=12" alt="Chat Support" class="gemini-chat-avatar" />
      <!-- Online Status Indicator -->
      <div class="gemini-online-status blink"></div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

const showNotification = ref(false)

onMounted(() => {
  // Show notification after 2 seconds when component is mounted
  setTimeout(() => {
    showNotification.value = true
  }, 2000)
})

const handleClick = () => {
  // Optional: Track click
  console.log('Chat button clicked - redirecting to Gemini')
}
</script>

<style scoped>
/* Chat Button Container */
.gemini-chat-button-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
}

/* Chat Button với Avatar */
.gemini-chat-button {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: white;
  border: 3px solid #e5e7eb;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  position: relative;
  text-decoration: none;
}

.gemini-chat-button:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  border-color: #667eea;
}

/* Avatar Image - thêm padding để không đè lên chấm xanh */
.gemini-chat-avatar {
  width: 58px;
  height: 58px;
  object-fit: cover;
  border-radius: 50%;
}

/* Online Status Indicator - chấm xanh */
.gemini-online-status {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 16px;
  height: 16px;
  background: #10b981;
  border: 3px solid white;
  border-radius: 50%;
  z-index: 10;
}

/* Hiệu ứng nhấp nháy sáng cho chấm xanh */
@keyframes blink {
  0%,
  100% {
    opacity: 1;
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
  }
  50% {
    opacity: 0.3;
    box-shadow: 0 0 10px 4px rgba(16, 185, 129, 0.5);
  }
}

.gemini-online-status.blink {
  animation: blink 2s ease-in-out infinite;
}

/* Notification Badge - hiện ngay trên chatbot */
.gemini-notification {
  position: absolute;
  top: -45px;
  right: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 10px 16px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  opacity: 0;
  transform: translateY(10px);
  pointer-events: none;
  z-index: 9998;
}

.gemini-notification.show {
  animation: slideInOut 10s ease-in-out forwards;
}

/* Mũi tên của notification */
.gemini-notification::after {
  content: '';
  position: absolute;
  bottom: -6px;
  right: 20px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #764ba2;
}

/* Animation hiện và tự ẩn sau 10s */
@keyframes slideInOut {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  90% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-10px);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .gemini-chat-button-container {
    bottom: 16px;
    right: 16px;
  }

  .gemini-chat-button {
    width: 56px;
    height: 56px;
  }

  .gemini-chat-avatar {
    width: 50px;
    height: 50px;
  }

  .gemini-online-status {
    width: 14px;
    height: 14px;
    border: 2px solid white;
  }

  .gemini-notification {
    font-size: 12px;
    padding: 8px 12px;
    top: -40px;
  }
}
</style>
